import { render } from "./SidenavItem.vue?vue&type=template&id=274c5202&scoped=true"
import script from "./SidenavItem.vue?vue&type=script&lang=js"
export * from "./SidenavItem.vue?vue&type=script&lang=js"

import "./SidenavItem.vue?vue&type=style&index=0&id=274c5202&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-274c5202"]])

export default __exports__